import React from 'react';
import PropTypes from 'prop-types';
import { ListItemIcon, ListItemText, IconButton } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

/**
 * The default content renderer for a list item in the DomainObjectManager.
 * Displays the resource's icon, its display name, and optional favorite star.
 */
const DefaultDomainObjectListItemContent = ({ item, config, isFavorite, onToggleFavorite }) => {
  const { icon: Icon, getDisplayName, renderDisplayName } = config;
  const ItemIcon = typeof Icon === 'function' ? Icon(item) : Icon;

  return (
    <>
      <ListItemIcon sx={{ minWidth: 36 }}>
        {ItemIcon && <ItemIcon />}
      </ListItemIcon>
      <ListItemText
        primary={
          renderDisplayName
            ? renderDisplayName(item)
            : getDisplayName(item)
        }
        primaryTypographyProps={{ variant: 'body2', noWrap: true }}
      />
      {onToggleFavorite && (
        <IconButton 
          size="small" 
          onClick={onToggleFavorite}
          sx={{ 
            ml: 0.5, 
            p: 0.5,
            // Fade out if not favorite, fade in on hover
            opacity: isFavorite ? 1 : 0.15,
            transition: 'opacity 0.2s ease-in-out',
            '&:hover': {
              opacity: 1,
            }
          }}
        >
          {isFavorite ? (
            <StarIcon fontSize="small" color="primary" />
          ) : (
            <StarBorderIcon fontSize="small" />
          )}
        </IconButton>
      )}
    </>
  );
};

DefaultDomainObjectListItemContent.propTypes = {
  item: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  isFavorite: PropTypes.bool,
  onToggleFavorite: PropTypes.func,
};

export default DefaultDomainObjectListItemContent;